'use client';

import { ReactNode } from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import { AnimatedText } from '@/blocks/animations/animated-text';
import { Container } from '@/blocks/components/Container';
import { AccentFragment } from '@/blocks/components/HeadingAccentFragment';
import { SectionsGroup } from '@/blocks/components/SectionsGroup';
import { CenterHeading, VStack } from '@/blocks/components/layout';
import { FaqBlock } from '@/blocks/sections/Questions';
import typography from '@/styles/typography.module.scss';

import { coinData } from '@/app/[lang]/buy-crypto/data';
import styles from '@/app/[lang]/cfd-trading/(pages)/(platforms)/mt5/[device]/MTFaqSection/styles.module.scss';

export const BuyCoinFaqSection = () => {
  const coin = useParams().coin as string;
  const tr = useTranslations('pages.buyCrypto.coins.sections.faq');

  const { name, ticker } = coinData[coin];

  const faqData: { question: ReactNode; answer: ReactNode }[] = [
    {
      question: tr.rich('items.0.question', { coin: name, coinTicker: ticker }),
      answer: tr.rich('items.0.answer', { coin: name, coinTicker: ticker }),
    },
    {
      question: tr.rich('items.1.question', { coin: name, coinTicker: ticker }),
      answer: tr.rich('items.1.answer', { coin: name, coinTicker: ticker }),
    },
    {
      question: tr.rich('items.2.question', { coin: name, coinTicker: ticker }),
      answer: tr.rich('items.2.answer', { coin: name, coinTicker: ticker }),
    },
    {
      question: tr.rich('items.3.question', { coin: name, coinTicker: ticker }),
      answer: tr.rich('items.3.answer', { coin: name, coinTicker: ticker }),
    },
    {
      question: tr.rich('items.4.question', { coin: name, coinTicker: ticker }),
      answer: tr.rich('items.4.answer', { coin: name, coinTicker: ticker }),
    },
  ];

  return (
    <SectionsGroup>
      <Container className={styles.faqSection}>
        <VStack>
          <CenterHeading>
            <AnimatedText className={classNames(typography.h2)}>
              {tr.rich('title', {
                coin: name,
                span: (content) => <AccentFragment>{content}</AccentFragment>,
              })}
            </AnimatedText>
          </CenterHeading>

          <FaqBlock questionsData={faqData} />
        </VStack>
      </Container>
    </SectionsGroup>
  );
};
